import i18n from "~/i18n/i18n";

export type JobStep = "Final" | "Start";

export const JOB_STEP_FILTER_VALUES: JobStep[] = ["Start", "Final"];

const JOB_STEP_LABEL_KEYS: Partial<Record<string, string>> = {
	Final: "schedule.jobStep.final",
	Start: "schedule.jobStep.start"
};

export const deriveJobStep = (parentProductionJobId: string | null | undefined): JobStep =>
	parentProductionJobId ? "Start" : "Final";

const formatJobStepLabel = (value: string | null | undefined): string => {
	const labelKey = value ? JOB_STEP_LABEL_KEYS[value] : undefined;
	return labelKey ? i18n.t(labelKey, { ns: "produce" }) : "";
};

export default formatJobStepLabel;
